import { Group, Radio, Text, Title, useMantineTheme } from "@mantine/core"
import { Card } from "@tfg/ui"

import { SubscriptionPlan } from "@tfg/types/endpoints/subscriptionPlan"

interface SubscriptionPlanCardProps {
  subscriptionPlan: SubscriptionPlan
  name: string
  description: string
  checked: boolean
  onClick: (subscriptionPlan: SubscriptionPlan) => void
  isAdmin: boolean
}

export const SubscriptionPlanCard = ({
  subscriptionPlan,
  name,
  description,
  checked,
  onClick,
  isAdmin,
}: SubscriptionPlanCardProps) => {
  const theme = useMantineTheme()
  const pointerStyle = isAdmin
    ? { cursor: "pointer" }
    : { cursor: "not-allowed" }

  const handleClick = () => {
    onClick(subscriptionPlan)
  }

  return (
    <Card
      w={350}
      h="-webkit-fill-available"
      withBorder
      style={{
        borderRadius: "16px",
        border: "2px solid",
        ...(checked
          ? { borderColor: theme.colors.primary[6] }
          : {
              borderColor: theme.colors.gray[3],
              backgroundColor: theme.colors.gray[0],
            }),
      }}
    >
      <Group wrap="nowrap" align="flex-start" w="100%">
        <Radio.Indicator
          checked={checked}
          style={pointerStyle}
          onClick={() => (isAdmin ? handleClick() : null)}
        />
        <div
          style={{
            flex: 1,
            minWidth: 0,
            whiteSpace: "normal",
            overflowWrap: "break-word",
            color: theme.black,
          }}
        >
          <Title
            style={{
              fontSize: theme.fontSizes.lg,
              fontWeight: "600",
              marginBottom: theme.spacing.md,
              textTransform: "capitalize",
            }}
          >
            {name.toLowerCase()}
          </Title>
          <Text>{description}</Text>
        </div>
      </Group>
    </Card>
  )
}
